import ErrorState from "../ErrorState/ErrorState";
import LoadingState from "../LoadingState/LoadingState";

// The only thing a data screen renders while loading or failed. Nothing else (toolbar, cards, tables) is shown.
export default function DataState({
  status,
  errorTitle,
  error,
  onRetry,
  skeletonRows = 6,
  skeletonCards = 0,
  skeletonToolbar = false,
  children,
}) {
  if (status === "error") {
    return (
      <ErrorState
        title={errorTitle}
        description={error}
        onRetry={onRetry}
      />
    );
  }

  if (status === "loading") {
    return (
      <LoadingState
        rows={skeletonRows}
        cards={skeletonCards}
        toolbar={skeletonToolbar}
      />
    );
  }

  return children;
}
